import m, { redraw } from 'mithril'

const Component=  {

    onupdate: vnode => {
        let el = document.getElementById('slider')
        vnode.state.width = el.offsetWidth
    },

    view: function (vnode) {
        // console.log(vnode.attrs.min, vnode.attrs.max)
        return [

            m('.range_slider',
                {
                    class: 'unselectable' + (vnode.attrs.flash ? ' flash' : ''),
                    id: 'slider'
                },
                m('.range_slider-range'),
                m(cover, {
                    min: vnode.attrs.min, max: vnode.attrs.max
                }),
                m(circle, {
                    n: 1,
                    x: (vnode.attrs.min),
                    move: x => {
                        let new_x = vnode.attrs.min + x
                        new_x = Math.max(new_x, 0)
                        new_x = Math.min(new_x, 200)
                        new_x = Math.min(new_x, vnode.attrs.max - 30)
                        vnode.attrs.change_min(100 * (x / vnode.state.width))

                    }
                }
                ),
                m(circle, {
                    n: 2, x:
                        (vnode.attrs.max),
                    move: x => {
                        let new_x = vnode.attrs.max + x
                        new_x = Math.max(new_x, 0)
                        new_x = Math.min(new_x, 200)
                        new_x = Math.max(new_x, vnode.attrs.min + 30)
                        vnode.attrs.change_max(100 * (x / vnode.state.width))
                    }
                }),

            )
        ]
    }

}

const circle = {
    view: vnode => m('.range_slider-circle', {
        style: 'left: ' + (vnode.attrs.x) + '% !important;',
        onmousedown: () => {
            let move_listener = e => {
                // console.log(e)
                vnode.attrs.move(e.movementX)
                redraw()
            }
            let up_listener = event => {
                document.removeEventListener('mousemove', move_listener)
                document.removeEventListener('mouseup', up_listener)
            }

            document.addEventListener('mousemove', move_listener)
            document.addEventListener('mouseup', up_listener)
        },

        onpointerdown: (e) => {
            vnode.state.touchpoint = e.x
            let move_listener = e => {
                vnode.attrs.move(e.touches[0].clientX - vnode.state.touchpoint)
                vnode.state.touchpoint = e.touches[0].clientX
                redraw()
            }
            let up_listener = event => {
                document.removeEventListener('touchmove', move_listener)
                document.removeEventListener('touchend', up_listener)
            }

            document.addEventListener('touchmove', move_listener)
            document.addEventListener('touchend', up_listener)
            document.addEventListener('touchcancel', up_listener)

        }

    },

        //    m('', '' + 100 * Math.ceil((vnode.attrs.x / 10000) * max_words) + ' words')

    )
}

const cover = {

    oninit: vnode => {
        vnode.state.tutorial = true
        vnode.state.start_point = vnode.attrs.min
    },

    onupdate: vnode => {
        if (vnode.state.tutorial) {
            if (vnode.state.start_point != vnode.attrs.min) {
                vnode.state.tutorial = false
            }
        }
    },

    view: vnode => [

        m('.range_slider-covered',
            {
                style: 'left: ' +
                    (vnode.attrs.min) +
                    '% !important; width: ' +
                    (vnode.attrs.max - (vnode.attrs.min)) +
                    '% !important;',

            },

            // (vnode.state.tutorial) ? m(Icons.drag) : []
        )
    ]
}

export default Component